/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const MoveHorizontal = [
  "svg",
  defaultAttributes,
  [
    ["polyline", { points: "18 8 22 12 18 16" }],
    ["polyline", { points: "6 8 2 12 6 16" }],
    ["line", { x1: "2", x2: "22", y1: "12", y2: "12" }]
  ]
];

export { MoveHorizontal as default };
//# sourceMappingURL=move-horizontal.js.map
